import { Action, createReducer, on } from "@ngrx/store";
import { AppState, initialAppState } from "../states/app.state";

import { AppHelper } from "src/app/helpers/app.helper";
import { InfoTab } from "src/app/models/WebServer/agencySettings";
import { AppModesEnum } from "src/app/models/WebServer/appModesEnum";
import { MediaTypesEnum } from "src/app/models/WebServer/mediaTypesEnum";
import { Message } from "src/app/models/WebServer/message";
import { PartecipantInfo } from "src/app/models/WebServer/partecipantInfo";
import { PartecipantRoles } from "src/app/models/WebServer/partecipantRoles";
import { Session } from "src/app/models/WebServer/session";
import { initialSessionConfig } from "src/app/models/WebServer/sessionConfig";
import { TranslationInfo } from "src/app/models/WebServer/translationInfo";
import { PhoneStatusEnum } from "src/app/models/phoneStatus";
import { AppConfigService } from "src/app/services/app.config.service";
import { I18Service } from "src/app/services/i18.service";
import { ErrorInfo } from "../../models/errorInfo";
import * as appActions from "../actions/app.actions";
import * as phoneActions from "../actions/phone.actions";
import * as sessionActions from "../actions/session.actions";

const appStateReducer = createReducer(
    initialAppState,
    on(appActions.configLoaded, (state: AppState, { config, partecipant }) => {

        let errorInfo: ErrorInfo | undefined;

        if (!partecipant.id) { // strange.., so.. ERROR
            errorInfo = new ErrorInfo();
            errorInfo.message = I18Service.get('POPUP.SESSIONNOTFOUNDBODY');
            errorInfo.showReloadButton = false;
        }
        const isCaller = partecipant.role == PartecipantRoles.SecondaryClient;
        const isReceiver = partecipant.role == PartecipantRoles.PrimaryClient || partecipant.role == PartecipantRoles.SuperClient;
        const isGuest = partecipant.role == PartecipantRoles.GuestClient || partecipant.role == PartecipantRoles.OnSiteOperator;
        const appModes = (isGuest) ? [AppModesEnum.Chat] : []
        // console.log(`config loaded => partecipantId: ${partecipantId} - isCaller: ${isCaller} - isReceiver: ${isReceiver}`);
        return {
            ...state,
            ...{
                errorInfo,
                partecipantId: partecipant.id,
                isCaller,
                isReceiver,
                isGuest,
                role: partecipant.role,
                // commandsDisabled: isGuest, //non disabilitare i comandi al guest

                appModes,
                //config,
                // signalRHub: {
                //     automaticReconnect: true,
                //     url: config.signalRUlr,
                //     hubName: ''
                // }
            }
        }
    }),

    on(appActions.loadingMessage, (state: AppState, { message }) => {
        console.log(`***** appActions.loadingMessage => ${message}`);
        return {
            ...state,
            loadingMessage: message
        }
    }),
    on(appActions.signalrHubConnected, (state: AppState, { connectionId }) => {
        console.log(`***** app.reducer signalrHubConnected called with connectionId: "${connectionId}" (previous: "${state.signalrConnectionId}")`);

        // Durante suspended mode, mantieni appReady come era per evitare distruzione componenti
        const newAppReady = state.isSuspended
            ? state.appReady
            : (!!state.sessionLoaded && !!state.wssSipRegistered && !!connectionId);

        if (newAppReady !== state.appReady) {
            console.log(`***** appReady changed: ${state.appReady} => ${newAppReady} [signalrHubConnected] (sessionLoaded:${!!state.sessionLoaded}, wssSipRegistered:${!!state.wssSipRegistered}, connectionId:${!!connectionId}, isSuspended:${!!state.isSuspended})`);
        }

        return {
            ...state,
            ...{ signalrConnectionId: connectionId, appReady: newAppReady}
        }
    }),

    on(sessionActions.sessionLoaded, (state: AppState, _) => {
        const newAppReady = !!state.signalrConnectionId && !!state.wssSipRegistered;

        if (newAppReady !== state.appReady) {
            console.log(`***** appReady changed: ${state.appReady} => ${newAppReady} [sessionLoaded] (sessionLoaded:true, wssSipRegistered:${!!state.wssSipRegistered}, connectionId:${!!state.signalrConnectionId})`);
        }

        return {
            ...state,
            ...{ sessionLoaded: true, appReady: newAppReady }
        }
    }),
    on(appActions.wssSipRegistered, (state: AppState, { is }) => {
        const newPhoneStatus = state.phoneStatus != PhoneStatusEnum.NONE ? state.phoneStatus : PhoneStatusEnum.IDLE;

        // Durante suspended mode, mantieni appReady come era per evitare distruzione componenti
        const newAppReady = state.isSuspended
            ? state.appReady
            : (!!state.sessionLoaded && !!state.signalrConnectionId && (is || state.isReceiver));

        if (newAppReady !== state.appReady) {
            console.log(`***** appReady changed: ${state.appReady} => ${newAppReady} [wssSipRegistered] (sessionLoaded:${!!state.sessionLoaded}, wssSipRegistered:${is}, connectionId:${!!state.signalrConnectionId}, isSuspended:${!!state.isSuspended}, isReceiver:${state.isReceiver})`);

            // [PERF-LOAD-18] APP READY TRUE
            if (newAppReady) {
                const perfNow = performance.now();
                const elapsed = perfNow - ((window as any).perfMarks?.browserStart || 0);
                console.log(`[PERF-LOAD-18] APP READY TRUE - sessionLoaded: ${!!state.sessionLoaded}, wssSipRegistered: ${is}, connectionId: ${!!state.signalrConnectionId} | Time: ${perfNow.toFixed(2)}ms | Elapsed: ${elapsed.toFixed(2)}ms`);
            }
        }

        return {
            ...state,
            ...{ wssSipRegistered: is, appReady: newAppReady, phoneStatus: newPhoneStatus }
        }
    }),

    on(appActions.showErrorPage, (state: AppState, { message, imagePath, showReload }) => {
        var ei = state.errorInfo;
        if (!ei) {
            ei = new ErrorInfo();
            ei.message = message;
            ei.showReloadButton = (showReload !== undefined) ? showReload : ei.showReloadButton;
            if (imagePath !== undefined && AppHelper.fileExists(imagePath)) {
                ei.imagePath = imagePath;
            }
        }
        return {
            ...state,
            ...{ errorInfo: ei} //, sessionLoaded: true }
        }
    }),

    on(sessionActions.sessionOk, sessionActions.sessionReload, (state: AppState, { session }) => {
        console.log(`session ok`, session);
        const sss = AppHelper.deepCopy(session) as Session;
        // Deep merge sessionConfig: i valori di session.config sovrascrivono initialSessionConfig,
        // ma per oggetti annidati (es. agencySettings.whiteboard) vengono preservate le proprietà non inviate dal server
        const sessionConfig = AppHelper.deepMerge(initialSessionConfig, session.config);
        // sessionConfig.agencySettings.agency = session.agency;
        const expired = new Date(session.expiration) < new Date()

        //fai aprire tab-sessione in caso di on-site-op
        const onsiteOps = sss.parameters.partecipantIds.filter(z => z.partecipantRole == PartecipantRoles.OnSiteOperator)
        if ( onsiteOps.length) { 
            sessionConfig.agencySettings.openTabInfo = InfoTab.Session;
            if (onsiteOps.length > 1){
                onsiteOps[0].active = false;
            }
        }

        // sss.expiration = new Date(new Date().getTime() + 150*1000);// forziamo scadenza a 150 sec per test rinnovo

        const newState = {
            ...state,
            ...{ session: { ...sss, ...{ config: sessionConfig } }, sessionExpired: expired }
        }
        const  messages = setInterlocutor(state.messages, state);
        newState.messages = messages;

        return newState;
    }),

    on(sessionActions.partecipantOk, (state: AppState, { partecipant }) => {
        console.log(`partecipant ok => partecipantInfo: `, partecipant);
        return {
            ...state,
            ...{ myPartecipantInfo: partecipant}
        }
    }),

    on(appActions.pageStateChange, (state: AppState, { nextState }) => {
        return {
            ...state,
            ...{ pageStatus: nextState }
        }
    }),
    on(appActions.appModeChange, (state: AppState, { mode }) => {
        var videoEnabled = state.videoEnabled;
        let appModes = [...state.appModes];
        // se c'è già.. rimuove se NON è "unico" (toggle)
        if (appModes.includes(mode) && appModes.length > 1) {
            appModes = appModes.filter(x => x !== mode)
        // }
        // else if (state.isGuest) {
        //     appModes = [mode]
        } else { // aggiungiamo ma se Video togliamo foto, se Photo togliamo video

            switch (mode) {
                case AppModesEnum.Map:
                    appModes = [AppModesEnum.Map]; // Map è esclusivo
                    videoEnabled = false;
                    break;
                case AppModesEnum.Video:
                    appModes = appModes.filter(x => x !== AppModesEnum.Photo && x !== AppModesEnum.Map);
                    break;
                case AppModesEnum.Photo:
                    appModes = appModes.filter(x => x !== AppModesEnum.Video && x !== AppModesEnum.Map);
                    break;
                case AppModesEnum.Chat:
                    appModes = appModes.filter(x => x !== AppModesEnum.Map);
                    break;
            }

            if (mode != AppModesEnum.Map && !appModes.includes(mode)) {
                appModes.push(mode);
            }


        }
        const appInMultimedia = appModes.length > 0 && !appModes.includes(AppModesEnum.Map);

        // console.log(`appModeChange: videoEnabled ${videoEnabled} => ${appModes} zzzzzzzzz`);
        if ((state.isCaller) && mode == AppModesEnum.Video) {
            videoEnabled = appModes.includes(AppModesEnum.Video) ? true : false;
        }

        console.log(`appModeChange: ${mode} => ${appModes} zzzzzzzzz videoEnabled: ${videoEnabled}`);
        console.log(`[APPMODES] appModeChange → mode: ${mode}, resultModes: [${appModes}], length: ${appModes.length}, includesMap: ${appModes.includes(AppModesEnum.Map)}, appInMultimedia: ${appInMultimedia}`);

        return {
            ...state,
            ...{ appModes, appInMultimedia, videoEnabled }
        }
    }),
    on(appActions.setAppModes, (state: AppState, { modes }) => {
        console.log(`setAppModes: ${modes} zzzzzzzzz`);
        const appInMultimedia = modes.length > 0 && !modes.includes(AppModesEnum.Map);
        console.log(`[APPMODES] setAppModes → modes: [${modes}], length: ${modes.length}, includesMap: ${modes.includes(AppModesEnum.Map)}, appInMultimedia: ${appInMultimedia}`);
        var videoEnabled = state.videoEnabled;
        if (state.isCaller) {
            videoEnabled = modes.includes(AppModesEnum.Video) ? true : false;
        }
        return {
            ...state,
            ...{ appModes: modes, appInMultimedia, videoEnabled }
        }
    }),
    on(appActions.openVideoSection, (state: AppState) => {

        const appModes = [...state.appModes];
        const videoEnabled = state.videoEnabled;
        if (videoEnabled && !appModes.includes(AppModesEnum.Video)){
            appModes.push(AppModesEnum.Video);
        }
        console.log(`openVideoSection ${appModes} zzzzzzz`);
        return {
            ...state,
            ...{appModes}
        }
    }),
    on(appActions.retrieveDevices, (state, { availableDevices }) => {
        return { ...state, ...{ availableDevices} }
    }),
    on(sessionActions.chatHistoryLoaded, (state: AppState, { messages }) => {


        if (messages.find(z => !z.rtpCallId)) {
            console.log(`*********** HISTORY LOADED messages without rtpCallID`, messages.filter(z => !z.rtpCallId));
        }


        var chatMessages = setInterlocutor(messages.filter(z => !z.type || z.type == MediaTypesEnum.Document || z.type == MediaTypesEnum.Image), state) //#92039 (si potrebbe semplificare e metter tutto dentro)
        var mediaMessages = setInterlocutor(messages.filter(z => z.type == MediaTypesEnum.Image || AppConfigService.isImage(z)), state)

        const currentChats = [...state.messages];
        chatMessages = mergeMessages(chatMessages, currentChats);//chatMessages.concat(currentChats);

        const currentMedia = [...state.mediaMessages];
        mediaMessages = mergeMessages(mediaMessages, currentMedia);//mediaMessages.concat(currentMedia);

        const unreadMessage = chatMessages.filter(z => !z.messageInfo?.readAt && !z.me);
        const unseenImages = mediaMessages.filter(z => !z.messageInfo?.readAt && !z.me);
        console.log(`loaded chat messages ${chatMessages.length} - current: ${currentChats.length} - unread: ${unreadMessage.length} - unseen images: ${unseenImages.length}`, unreadMessage  );
        return {
            ...state,
            ...{ messages: chatMessages, mediaMessages: mediaMessages, messagesLoaded: true, unreadMessage: unreadMessage.length, unseenImages: unseenImages.length }
        }
    }),
    on(appActions.sendTextMessage, (state: AppState, { body, id, trInfo }) => {
        const messages = [...state.messages];
        const myMsg: Message = createMessage(state.partecipantId, body, trInfo, state, id);
        messages.push(myMsg);

        //console.log(`====sendTextMessage chat messages - current: ${messages.length}`);
        return {
            ...state,
            ...{ messages }
        }
    }),
    on(appActions.recvTextMessage, (state: AppState, { body, from, trInfo, rtpCallId, contentLanguage }) => {
        const messages = [...state.messages];
        const msg: Message = createMessage(from, body, trInfo, state, rtpCallId);
        msg.contentLanguage = contentLanguage;
        messages.push(msg);        
        const unreadMessage = messages.filter(z => !z.messageInfo?.readAt && !z.me).length;
        console.log(`====recvTextMessage chat messages - current: ${messages.length} - unread:${unreadMessage}`, messages);
        return {
            ...state,
            ...{ messages, unreadMessage }
        }
    }),
    on(appActions.updateMessage, (state: AppState, {message}) => {
        const myId = state.partecipantId;
        const myMessage = message.from.toLowerCase() == myId.toLowerCase()
        const trMsg = {...message};
        setTranslatedContent(trMsg, state.isCaller, myMessage);
        return{
            ...state,
            messages: state.messages.map((z, i) => z.rtpCallId == message.rtpCallId ? trMsg : z)
        }
    }),
    on(appActions.recvMediaMessage, (state: AppState, { message }) => {

        const m = setInterlocutor([message], state)[0];
        const messages = [...state.messages];
        const mediaMessages = [...state.mediaMessages];
        if (m.type == MediaTypesEnum.Document || m.type == MediaTypesEnum.Image) { //#92039 ora anche le immagini inviate da cittadino vanno in chat
            messages.push(m);
        }
        if (m.type == MediaTypesEnum.Image || AppConfigService.isImage(m)) {
            mediaMessages.push(m);
        }

        const unreadMessage = messages.filter(z => !z.messageInfo?.readAt && !z.me);
        const unseenImages = mediaMessages.filter(z => !z.messageInfo?.readAt && !z.me);
        console.log(`recvMediaMessage - unread: ${unreadMessage.length} - unseen images: ${unseenImages.length}`, unreadMessage  );

        return {
            ...state,
            ...{ messages, mediaMessages, unreadMessage: unreadMessage.length, unseenImages: unseenImages.length }
        }
    }),

    on(appActions.toggleRemoteCommand, (state: AppState, { enabled }) => {
        var commandsDisabled: boolean;
        if (enabled === null)
            commandsDisabled = !state.commandsDisabled;
        else
            commandsDisabled = enabled;
        return {
            ...state,
            ...{ commandsDisabled }
        }
    }),
    on(appActions.mirrorUser, (state: AppState, { enabled }) => {
        return {
            ...state,
            ...{ mirrorUser: enabled }
        }
    }),
    on(appActions.toggleVideo, (state: AppState) => {
        const videoEnabled = !state.videoEnabled;
        console.log(`toggleVideo new=>${videoEnabled} zzzzzzz`);
        return {
            ...state,
            videoEnabled
        }
    }),
    // on(appActions.streamVideoDraw, (state: AppState, {enabled}) => {
    //     return {
    //         ...state,
    //         videoEnabled: enabled
    //     }
    // }),
    on(appActions.myAppStateChange, (state: AppState, {partecipantStatus}) =>{
        const modes = partecipantStatus.appModes || [];
        const appInMultimedia = modes.length > 0 && !modes.includes(AppModesEnum.Map);
        console.log(`[APPMODES] myAppStateChange → modes: [${modes}], appInMultimedia: ${appInMultimedia}`);

        return {
            ...state,
            mediaPermission: partecipantStatus.mediaPermissionGiven,
            isRegistered: partecipantStatus.isRegistered || false,
            videoEnabled: partecipantStatus.videoEnabled || false,
            microphoneEnabled: partecipantStatus.microphoneEnabled || false,
            appModes: modes,
            phoneStatus: partecipantStatus.phoneStatus || PhoneStatusEnum.NONE,
            appInMultimedia: appInMultimedia,
            commandsDisabled: partecipantStatus.commandsDisabled || false,
        }
    }),
    on(appActions.toggleMicrophone, (state: AppState) => {
        const microphoneEnabled = !state.microphoneEnabled;
        return {
            ...state,
            ...{ microphoneEnabled }
        }
    }),
    on(sessionActions.terminateSession, (state: AppState) => { //inviato dal primary
        return {
            ...state,
            ...{ sessionExpired: true, sessionExtending: false }
        }
    }),
    on(sessionActions.extendSession, (state: AppState) => { //inviato dal primary
        return {
            ...state,
            ...{ sessionExpired: false, sessionExtending: true }
        }
    }),
    on(appActions.sessionExpired, (state: AppState) => { //ricevuto dal primary
        return {
            ...state,
            ...{ sessionExpired: true, sessionExtending: false }
        }
    }),
    // on(sessionActions.terminateSession, (state: AppState) => { //TODO: stabilire cosa fare su receiver quando si termina sessione
    //     return {
    //         ...state,
    //         ...{commandsDisabled: true}
    //     }
    // }),
    on(phoneActions.phoneChangeStatus, (state: AppState, { status }) => {
        return {
            ...state,
            phoneStatus: status
        }
    }),
    on(appActions.batteryLevel, (state: AppState, { level }) => {
        return {
            ...state,
            ...{ batteryLevel: level }
        }
    }),
    // on(appActions.connectionSpeed, (state: AppState, { speed }) => {
    //     return {
    //         ...state,
    //         ...{ connectionSpeed: speed }
    //     }
    // }),
    on(sessionActions.lastServerPosition, (state: AppState, { evt }) => {
        const coords = evt.data?.geoLocInfo
        return {
            ...state,
            ...{ lastPositionData: { time: new Date(evt.timestamp || 0), coords: coords } }
        }
    }),

    on(appActions.markMediaAsSeen, (state: AppState, { mediaIdx }) => {
        const mediaMessages = [...state.mediaMessages];
        const m = { ...mediaMessages[mediaIdx] };
        var unseenImages = state.unseenImages
        if (m) {

            unseenImages--;
            if (unseenImages < 0) unseenImages = 0;
            mediaMessages[mediaIdx] = setReadAt(m);
        }
        return {
            ...state,
            ...{ mediaMessages, unseenImages }
        }
    }),
    on(appActions.markMessageDelivered, (state: AppState, { message }) => {
        const messages = [...state.messages];

        function setDeliveredAt(m: Message): Message {
            if (m.messageInfo && m.messageInfo.deliveredAt) {
                return m
            }

            const newMessage = { ...m };
            newMessage.messageInfo = { readAt: m.messageInfo?.readAt, deliveredAt: new Date() };
            return newMessage;
        }
        messages.forEach((m, idx) => {
            const deliveredMessage = message as Message;
            if (message == 'all' || (m.content == deliveredMessage.content && m.from == deliveredMessage.from)) {
                const mm = {...m}
                messages[idx] = setDeliveredAt(mm);
            }
        });
        return {
            ...state,
            ...{ messages }
        }
    }),
    on(appActions.markMessageAsRead, (state: AppState, { message }) => {
        const messages = [...state.messages];


        if (message == 'all') {

            messages.forEach((m, idx) => {
                m
                if (!m.messageInfo?.readAt && !m.me)
                    messages[idx] = setReadAt(m);
            });
        }
        else {
            const deliveredMessage = message as Message;
            const m = messages.find(z => z.rtpCallId == deliveredMessage.rtpCallId)
            if (m) {
                setReadAt(m);
            }
        }
        const unreadMessage = messages.filter(z => !z.messageInfo?.readAt && !z.me).length;
        return {
            ...state,
            ...{ messages, unreadMessage }
        }
    }),
    on(appActions.markMyMessageAsRead, (state: AppState, { message }) => {
        const messages = [...state.messages];
        if (message == 'all') {
            messages.forEach((m, idx) => {
                if (!m.messageInfo?.readAt && m.me)
                    messages[idx] = setReadAt(m);
            });
        }
        else {
            const deliveredMessage = message as Message;
            const m = messages.find(z => z.content = deliveredMessage.content)
            if (m) {
                setReadAt(m);
            }
        }
        return {
            ...state,
            ...{ messages }
        }
    }),
    on(sessionActions.expirationUpdated, (state: AppState, { newExpiration }) => {
        console.log(`expiration updated => partecipant: `, newExpiration);

        const newSession: Session = {
            ...state.session, ...{
                expiration: newExpiration
            }
        };
        return {
            ...state,
            ...{ session: newSession, sessionExtending: false }
        }
    }),

    on(appActions.translationAuto, (state: AppState, {auto}) =>{
        return {
            ...state,
            ...{translationAuto: auto}
        }
    }),

    on(appActions.translationSelectedLanguage, (state: AppState, {lang}) =>{
        return {
            ...state,
            ...{translationSelectedLanguage: lang}
        }
    }),

    on(appActions.changeLanguage, (state: AppState, {lang})=>{

        return {
            ...state,
            ...{guiLanguage: lang, messages: setInterlocutor(state.messages, state)}
        }
    }),
    on(appActions.operatorZoomId, (state: AppState, {id})=>{
        // console.log(`app.reducer operatorZoomId => ${id}`)
        return {
            ...state,
            ...{operatorZoomId: id}
        }
    }),
    
    on(appActions.setSuspended, (state: AppState, {message})=>{
        console.log(`app.reducer setSuspended => "${message}"`)

        // IMPORTANTE: Non ricalcolare appReady quando usciamo da suspended mode
        // Lasciamo che sia la riconnessione effettiva (signalrHubConnected, wssSipRegistered)
        // a impostare appReady correttamente, evitando il ciclo true→false→true
        // che causerebbe la chiamata di afterLoadInit() e il redirect alla home

        return {
            ...state,
            isSuspended: message
            // appReady rimane invariato - verrà aggiornato dai reducer di connessione
        }
    }),
    on(appActions.gpsProblems, (state: AppState, { hasProblems })=>{
        return {
            ...state,
            ...{ gpsProblems: hasProblems }
        }
    }),
);

export function appReducer(state: AppState | undefined, action: Action) {
    return appStateReducer(state, action);
}

// function createWhiteboardData(state: AppState): WhiteboardData {
//     var whiteboardData: WhiteboardData =  AppHelper.deepCopy(state.whiteboardSharedData);
//     if (!whiteboardData) {
//         whiteboardData = { elements:[], who: '' } //, zoom: 1, canvasPosition: {x:0,y:0}};  
//     }
//     return whiteboardData
// }


function createMessage(from: string, body: string, trInfo: TranslationInfo[] | undefined, state: AppState, rtpCallId?: string): Message {

    const msg: Message = setInterlocutor(
        [{            
            idx: 0,
            from,
            content: body,
            translationInfo: trInfo,
            timestamp: new Date(),
            rtpCallId: rtpCallId,
        }], state)[0];

    return msg;
}

function setInterlocutor(msgs: Message[], state: AppState): Message[] {
    const myId = state.partecipantId;
    const partecipantIds: PartecipantInfo[] = state.session.parameters.partecipantIds
    // state.sess
    return msgs.map(x => {
        const msg: Message = { ...x };
        const myMessage = x.from.toLowerCase() == myId.toLowerCase()
        if (myMessage) {
            msg.me = true;
            // msg.from = I18Service.get('Chat.Me');
            msg.alias = I18Service.get('Chat.Me');

        } else {
            msg.me = false;
            const partecipantInfo = partecipantIds.find(z => z.partecipantId == x.from);
            msg.idx = partecipantIds.findIndex(z => z.partecipantId == x.from);
            var alias = I18Service.roleAndAlias(partecipantInfo);
            
            msg.alias = alias ?? msg.from;
            msg.role = partecipantInfo?.partecipantRole;
        }
        setTranslatedContent(msg, state.isCaller, myMessage);
        return msg
    });
}

function setTranslatedContent(msg: Message, isCaller: boolean, isMyMessage: boolean) {
    const trInfo = msg.translationInfo;
        
    const lang = I18Service.getNavigatorLanguage();
    // console.log(`*** translation myLang ${lang} - iamCaller: ${isCaller} - isMymessage: ${isMyMessage} => ${msg.content}`)
    var trInfoForMe = trInfo ? trInfo.find( z => z.targetLanguage == lang) : undefined; //guest

    if(isCaller || isMyMessage) trInfoForMe = trInfo ? trInfo.find( z => msg.from == z.owner) : undefined; // fix per caller #64973
    
    if( trInfoForMe && trInfoForMe.targetLanguage == trInfoForMe.startingLanguage) trInfoForMe = undefined; // viene nascosta la traduzione

    if (trInfoForMe){
        msg.translatedInfo = trInfoForMe;
    }
}

function setReadAt(m: Message): Message {
    if (m.messageInfo?.readAt) {
        return m
    }
    const newMessage = { ...m };
    newMessage.messageInfo = { ...m.messageInfo, ...{ readAt: new Date() } }

    return newMessage;
}

function mergeMessages(m1: Message[], m2: Message[]): Message[] {
    const merged: Message[] = [...m1];

    const missing = m2.filter( e => !m1.some( z => z.rtpCallId === e.rtpCallId));
    if (missing.length) console.log(`********************** missing ${missing.length}`, missing, m1, m2);
    missing.forEach( m => {
        const index = m1.findIndex(event => new Date(event.timestamp) > new Date(m.timestamp));
    
        if (index === -1) {
            // If no such index is found, the new event has the latest timestamp and should be added to the end
            merged.push(m);
        } else {
            // Otherwise, insert the new event at the found index
            merged.splice(index, 0, m);
        }
    });
    
    return merged;
}

